import Animation from 'Scripts/components/Animation'
import { gsap } from "gsap"
import { Flip } from "gsap/Flip"
gsap.registerPlugin(Flip)

export default class {
  constructor(trigger, wrapper) {
    this.trigger = trigger instanceof HTMLElement ? trigger : document.querySelector(trigger)
    this.wrapper = wrapper instanceof HTMLElement ? wrapper : document.querySelector(wrapper)
    //
    this.onClick = this.onClick.bind(this)
    this.page = this.trigger.dataset.page || 1
    this.perPage = this.trigger.dataset.perpage || 5
    this.count = this.trigger.dataset.count || 0
    this.limit = this.totalPages()

    // console.log("pagination : " + this.page, this.perPage, this.count, this.limit, this.wrapper)
    //Methods
    this.trigger && this.wrapper && this.create()
  }

  create() {
    this.trigger.addEventListener('click', this.onClick, false)
  }

  destroy() {
    this.trigger.removeEventListener('click', this.onClick, false)
  }


  onClick(event) {
    event.preventDefault()

    // this.module = event.target.dataset.module
    // this.category = event.target.dataset.category
    // this.page = event.target.dataset.page || 1
    // this.perPage = event.target.dataset.perpage || 5
    // this.count = event.target.dataset.count || 0
    // // this.limit = event.target.dataset.limit || 1
    // this.limit = this.totalPages()    
    this.nextPage()
    // new Animation({ selector: '[data-animation]' })
    // new Animation({ selector: '[data-scroll]' })
    // this.emitEvent()
  }

  totalPages() {
    return Math.ceil(this.count / this.perPage);
  }

  prevPage() {
    if (this.page > 1) {
      this.page--;
      this.change(this.page);
    }
  }

  nextPage() {
    if (this.page < this.limit) {
      this.page++
      this.change(this.page)
    }
  }

  change(page) {
    if (page < 1) page = 1;
    if (page > this.limit) page = this.limit
    if (page > 1) {
      this.state = Flip.getState(this.wrapper)
    }
    // console.log(this.state)
    for (let i = (page - 1) * this.perPage; i < (page * this.perPage); i++) {
      this.wrapper.children[i] && this.wrapper.children[i].classList.remove('is__hidden')
    }

    if (page > 1) {
      Flip.from(this.state, {
        
        duration: 0.5, 
        onComplete: () => {
          this.emitEvent()          
          new Animation({ selector: '[data-animation]' })          
          new Animation({ selector: '[data-scroll]' })
        }
      })
    }

    this.trigger.dataset.page = page

    if (page == this.limit) {
      // this.trigger.style.visibility = "hidden";
      this.trigger.classList.add('is__hidden')
    }
    // else {
    //   this.trigger.classList.remove('is__hidden')
    //   // this.trigger.style.visibility = "visible";
    // }

  }

  emitEvent() {
    window.dispatchEvent(new Event('resize'))
  }

}